import { EnumType } from "json-to-graphql-query";
import {
    CaseBlockRecord,
    CaseCarrouselRecord,
    ctaModel, CaseHero,
    ImageSliderRecord,
    CompaniesListRecord,
    QuoteRecord,
    RoiListRecord,
    SimpleTextRecord,
    TextRecord,
    UspListRecord, Cta2Record, CaseQuoteRecord
} from "queries/Blocks";
import { Image, SeoMeta } from "queries/Base";
import RoiList from "../blocks/roi/RoiList";

export const getAllCustomerStorySlugs = {
    allCustomerStories: {
        __args: {
            first: 100,
        },
        _allSlugLocales: {
            locale: true,
            value: true
        }
    }
};

export const getCustomersPage = (locale: string, limit = 10, skip = 0) => ({
    customer: {
        __args: {
            locale: new EnumType(locale)
        },
        id: true,
        content: {
            __on: [
                ...TextRecord,
                ...CompaniesListRecord,
                ...CaseHero
            ]
        },
        cta: ctaModel,
        ...SeoMeta
    },
    allCustomerStoryCategories: {
        __args: {
            locale: new EnumType(locale)
        },
        id: true,
        title: true
    }
});

export const CustomerStoryCategoryRecord = [
    {
        __typeName: "CustomerStoryCategoryRecord",
        __typename: true,
        id: true,
        title: true,
    }
];

export const CustomerStoryQuery = () => ({
    id: true,
    title: true,
    slug: true,
    hasDetailsPage: true,
    hideForThisLanguage: true,
    featuredImage: {
        ...Image
    },
    intro: {
        value: true
    },
    category: {
        __on: CustomerStoryCategoryRecord
    },
    content: {
        __on: [
            ...CaseHero,
            ...TextRecord,
            ...UspListRecord,
            ...ImageSliderRecord,
            ...CompaniesListRecord,
            ...CaseBlockRecord,
            // ...CaseCarrouselRecord,
            ...Cta2Record,
            ...CaseQuoteRecord,
            ...QuoteRecord,
            ...RoiListRecord,
            ...SimpleTextRecord,
        ]
    },
});

export const allCustomerStoriesQuery = (locale: string) => ({
    allCustomerStories: {
        __args: {
            locale: new EnumType(locale),
            filter: {
                slug: {
                    //@ts-ignore
                    neq: null
                }
            }
        },
        ...CustomerStoryQuery()
    }
});

export const getCustomerStoryBySlug = (slug: string, locale: string) => ({
    customerStory: {
        __args: {
            filter: {
                slug: { eq: slug },
            },
            locale: new EnumType(locale),
        },
        ...CustomerStoryQuery(),
        ...SeoMeta
    }
});
